import { IPatient, isPatient } from './ipatient';
import { IStudy } from './istudy';
import { IFilter } from './ifilter';
import { isWaveform, IWaveform } from './iwaveform';
import { isArray } from 'lodash-es';

export interface IEcgData {
    sopInstanceUID: string;

    title?: string;
    patient: IPatient;
    study: IStudy;
    filters: IFilter[] | null;

    originalWaveform: IWaveform;
    derivedWaveform: IWaveform;
}

export function isEcgData(object: any): object is IEcgData {
    let isEgcData: boolean = true;

    isEgcData = isEgcData && 'sopInstanceUID' in object;
    //isEgcData = isEgcData && 'title' in object;
    isEgcData = isEgcData && 'patient' in object && isPatient(object['patient']);
    isEgcData = isEgcData && 'study' in object;
    isEgcData = isEgcData && 'filters' in object && (object['filters'] === null || isArray(object['filters']));
    isEgcData = isEgcData && 'originalWaveform' in object && isWaveform(object['originalWaveform']);
    isEgcData = isEgcData && 'derivedWaveform' in object && isWaveform(object['derivedWaveform']);

    return isEgcData;
}
